import "./Reasons.scss";
import {
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  TextField,
} from "@mui/material";
import { useSelector } from "react-redux";
import { CheckBoxIcon, CheckBoxOutlineBlankIcon, CheckBoxOutlinedIcon } from "./SharedIcons";

export const RegionListDropDown = (props: any) => {

  const regionsList = useSelector((state: any) => state.ActionLoaderReducersState.regions); 
  const isEnterprise = useSelector((state: any) => state.ActionLoaderReducersState.isEnterprise);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxOutlinedIcon fontSize="small" />;
  interface dropDownOptions {id:string,name:string}
  return (
    <Autocomplete
      id="regions-dropdown"
      className="selectStore"
      value={props.region}
      multiple
      limitTags={1}
      disabled={isEnterprise}
      style={{ marginTop: 10, borderRadius: 4, width: "100%"}}
      getOptionLabel={(option) => option.name}
      onChange={(e, value) => { props.changeRegion(e, value) }}
      disableCloseOnSelect
      options={regionsList}
      isOptionEqualToValue={(option: dropDownOptions, value: dropDownOptions) => option.id === value.id}
      autoHighlight

      renderOption={(props, option: any, { selected }) => (
        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
            <li style={{fontSize:"small"}}>
                <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    //style={{ marginRight: 8 }}
                    checked={selected}
                />
                {option.name}
            </li>
        </Box>
      )}

      renderTags={(value:any, getTagProps) => {
        const numTags = value.length;
        const limitTags = 1;

        return (
          <>
            {value.slice(0, limitTags).map((option:any, index:any) => (
              <Chip
                {...getTagProps({ index })}
                size="small"
                key={index}
                label={option.name}
              />
            ))}

            {numTags > limitTags && ` +${numTags - limitTags}`}
          </>
        );
      }}
      
      
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={props.region.length==0 ? "Choose Region":""}
          style={{ background: "white", borderRadius: 4 }}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'off'
          }}
        />
      )}
    />
  );
};
